import { CustomTextInput } from '@Modules/core/components'
import { CorporateNameInputMeta } from '../../containers/forms/commonMeta'

type Props = {
  register?: any;
  hasError?: any;
}

const CustomCorporateNameTextInput: React.FC<Props> = ({register, hasError}) => {
  return (
    <CustomTextInput meta={CorporateNameInputMeta} register={register} hasError={hasError} defaultValue={'MA BANQUE'} />
  )
}

export default CustomCorporateNameTextInput